import Swiper from 'swiper/bundle';

export function swiperCampaign24() {
  return new Swiper('.cc24-swiper', {
    mousewheel: true,
    breakpoints: {
      320: {
        slidesPerView: 'auto',
        spaceBetween: 0
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0,
      }
    },
    navigation: {
      nextEl: '.cc24-page_arrow-container',
    },
  });
}
